import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import useQuery from '../../helpers/hooks/useQuery';
import accountService from '../../services/AccountService';
import PathCircularProgress from '../PathCircularProgress';

const VerifyEmailComponent = () => {
  let query = useQuery();
  let accountToken = query.get('token');

  const [statusMessage, setStatusMessage] = useState(
    accountToken ? '' : 'No Token Provided'
  );
  const [verificationError, setVerificationError] = useState(!accountToken);
  const [isLoading, setIsLoading] = useState(!!accountToken); // Set loading true immediately if token exists

  useEffect(() => {
    if (accountToken) {
      accountService
        .verifyEmail(accountToken)
        .then((response: any) => {
          setStatusMessage(response.message);
          setVerificationError(false);
          setIsLoading(false);
        })
        .catch((error: any) => {
          setStatusMessage(error?.message ?? 'An error occurred');
          setVerificationError(true);
          setIsLoading(false);
        });
    }
  }, [accountToken]);

  return (
    <>
      <Typography variant="h4" sx={{ mt: 8 }}>
        <strong>Verify Email</strong>
      </Typography>
      <Box
        sx={{
          mt: 2,
          mb: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {isLoading && (
          <PathCircularProgress data-testid="PathCircularProgress" />
        )}
        {!isLoading &&
          (verificationError ? (
            <ErrorOutlineIcon
              fontSize="large"
              color="error"
              data-testid="ErrorOutlineIcon"
            />
          ) : (
            <CheckCircleOutlineIcon
              fontSize="large"
              color="success"
              data-testid="CheckCircleOutlineIcon"
            />
          ))}
        <Typography
          variant="body1"
          color={verificationError ? 'error' : 'success'}
          sx={{ mt: 1 }}
          data-testid="StatusMessage"
        >
          {statusMessage}
        </Typography>
        {verificationError && (
          <Typography variant="body1" color="error" sx={{ mt: 1 }}>
            Please contact an administrator for further help
          </Typography>
        )}
      </Box>
    </>
  );
};

export default VerifyEmailComponent;
